var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ bodyDisabled: _vm.spinnerVisible }},[_c('pulse-loader',{attrs:{"loading":_vm.spinnerVisible,"color":"#187da0"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }